import { useEffect } from 'react'
import { DynamicHeaderState, useDynamicHeader } from '../../providers'
import { useSelector } from 'react-redux'
import { selectPermissions } from '../../store'

export const usePageHeader = (
  headerContent?: DynamicHeaderState,
  resetOnUnmount = true,
  extraDeps: React.DependencyList = []
) => {
  const props = useDynamicHeader()
  const permissions = useSelector(selectPermissions)

  useEffect(() => {
    if (headerContent) {
      props.setHeaderContent(headerContent)
    }

    return () => {
      if (resetOnUnmount) {
        props.setHeaderContent({})
      }
    }
  }, [headerContent?.headerTitle, resetOnUnmount, permissions, ...extraDeps])
}
